import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromSystemlog from './reducers/systemlog.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SystemlogEffects } from './effects/systemlog.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('systemlog', fromSystemlog.reducer),
    StoreModule.forFeature('systemlogtype', fromSystemlog.systemlogTypeReducer),
    EffectsModule.forFeature([SystemlogEffects])
  ]
})
export class SystemlogModule { }
